<p><mat-icon class="error-icon">error</mat-icon></p>
<p class="mat-headline-4 margin padding s4 bottom">{{'INTERNAL_USER_ERROR.oops' | translate}}</p>
<p>{{'INTERNAL_USER_ERROR.error' | translate}}</p>